export default function SectionHeader({ label, title, gradientWord, subtitle, align = "left" }) {
  const alignClass = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col ${alignClass} mb-14 md:mb-16 w-full`}>
      <span className="section-label">{label}</span>
      <h2 className="mt-5 w-full text-[2.75rem] sm:text-5xl md:text-6xl lg:text-7xl font-semibold tracking-tight leading-[1.05]">
        {title}{" "}
        <span className="gradient-text">{gradientWord}</span>
      </h2>
      {subtitle && (
        <p className="mt-5 w-full text-base md:text-lg text-gray-400 leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  );
}
